import { useTranslation } from 'react-i18next'
import CountryPhoneInput from '../shared/CountryPhoneInput'
import { inputClass, labelClass } from '../shared'

const PartnerPassagerClientFields = ({
  draft,
  setField,
  formErrors = {},
  appearance = 'default',
}) => {
  const { t } = useTranslation()
  const tamarra = appearance === 'tamarra'
  const pf = tamarra ? 'tamarra-pf' : undefined
  const inp = tamarra ? 'tamarra-pay-input' : inputClass

  return (
    <div className={tamarra ? 'tamarra-billing' : 'space-y-3'}>
      {tamarra ? (
        <h4 className="tamarra-grp">
          {t('transferts.reservations.billing.billingInfo')}
        </h4>
      ) : null}
      <p className={tamarra ? 'tamarra-bk-rate' : 'text-sm text-[var(--muted-foreground)]'}>
        {t('transferts.reservations.partnerPassenger.title')}
      </p>
      <div className={tamarra ? 'tamarra-billing-g' : 'grid grid-cols-1 gap-3 md:grid-cols-3'}>
        <label className={pf} htmlFor="partner_client_name">
          {tamarra ? (
            <span>{t('transferts.reservations.partnerPassenger.nameRequired')}</span>
          ) : (
            <span className={labelClass}>
              {t('transferts.reservations.partnerPassenger.nameRequired')}
            </span>
          )}
          <input
            id="partner_client_name"
            value={draft.client_name || ''}
            onChange={(e) => {
              const v = e.target.value
              setField('client_name', v)
              setField('billing_nom', v)
            }}
            className={inp}
            placeholder={t('transferts.reservations.partnerPassenger.fullNamePlaceholder')}
            aria-invalid={!!formErrors.client_name}
          />
          {formErrors.client_name ? (
            tamarra ? (
              <small className="tamarra-ferr" role="alert">
                {formErrors.client_name}
              </small>
            ) : (
              <p className="mt-1 text-sm text-[var(--destructive)]">{formErrors.client_name}</p>
            )
          ) : null}
        </label>
        <label className={pf} htmlFor="partner_client_email">
          {tamarra ? (
            <span>{t('transferts.common.email')}</span>
          ) : (
            <span className={labelClass}>{t('transferts.common.email')}</span>
          )}
          <input
            id="partner_client_email"
            type="email"
            value={draft.client_email || ''}
            onChange={(e) => {
              const v = e.target.value
              setField('client_email', v)
              setField('billing_email', v)
            }}
            className={inp}
            placeholder={t('transferts.reservations.form.emailPlaceholder')}
          />
        </label>
        <div className={tamarra ? 'tamarra-billing-phone' : undefined}>
          <CountryPhoneInput
            id="partner_client_phone"
            countryCode={draft.phone_country_code || '+216'}
            phone={draft.client_phone || ''}
            onCountryCodeChange={(v) => setField('phone_country_code', v)}
            onPhoneChange={(v) => {
              setField('client_phone', v)
              setField('billing_telephone', v)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default PartnerPassagerClientFields
